import { graphql } from '../gql'; // Ensure this is properly defined
import { useQuery } from '@apollo/client';

// Define the GraphQL query
export const GET_UW_REGION = graphql(`
  query getUnderwritingRegions($filters: UwTerritoryFilterInput) {
    uwTerritories(filters: $filters) {
      edges {
        node {
          uuid
          name
        }
      }
    }
  }
`);

export function useGetRegion() {
  const { loading, error, data } = useQuery(GET_UW_REGION, {});

  return { loading, error, data };
}
